{
  "familyId": "GET-BREUK-DEEL",
  "questions": [
    {
      "id": "GET-BREUK-DEEL-001",
      "familyId": "GET-BREUK-DEEL",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "skill": "breuken",
      "subSkill": "breuk_delen",
      "questionType": "fill_in",
      "question": "Vul de ontbrekende noemer in: $\\frac{3}{4} \\div \\frac{2}{3} = \\frac{9}{__}$",
      "options": ["8", "12", "6", "4"],
      "correctAnswer": 0,
      "data": {
        "fill_in": {
          "template": "$\\frac{9}{__}$",
          "correctValue": "8",
          "hint": "Delen door een breuk = keer het omgekeerde. $\\frac{3}{4} \\times \\frac{3}{2}$"
        }
      },
      "conceptId": "divide_fractions_fill",
      "variantIndex": 1,
      "group": 8,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "$\\frac{3}{4} \\div \\frac{2}{3}$ — draai $\\frac{2}{3}$ om en vermenigvuldig",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 9,
            "denominator": 8,
            "label": "3/4 ÷ 2/3 = 9/8",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Delen door een breuk = keer het omgekeerde. Stap 1: draai $\\frac{2}{3}$ om → $\\frac{3}{2}$. Stap 2: $\\frac{3}{4} \\times \\frac{3}{2}$ = $\\frac{3 \\times 3}{4 \\times 2}$ = $\\frac{9}{8}$. De noemer is dus 8.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{4} \\times \\frac{3}{2}$ = $\\frac{9}{8}$. Teller: 3×3=9, noemer: 4×2=8.",
          "1": "12 is niet correct. Je hebt waarschijnlijk 4×3=12 berekend zonder het omgekeerde te nemen. Draai eerst $\\frac{2}{3}$ om naar $\\frac{3}{2}$, dan is de noemer 4×2=8.",
          "2": "6 is niet correct. Controleer: noemer = 4×2=8, niet 4+2=6. Vermenigvuldig de noemers, tel ze niet op.",
          "3": "4 is de noemer van de eerste breuk, niet van het antwoord. Na het omdraaien van $\\frac{2}{3}$ geldt: noemer = 4×2=8."
        }
      }
    },
    {
      "id": "GET-BREUK-DEEL-002",
      "familyId": "GET-BREUK-DEEL",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "skill": "breuken",
      "subSkill": "breuk_delen",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\frac{1}{2} \\div \\frac{1}{4}$",
      "options": ["2", "$\\frac{1}{8}$", "$\\frac{2}{4}$", "4"],
      "correctAnswer": 0,
      "conceptId": "divide_fractions_simple",
      "variantIndex": 1,
      "group": 8,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "Hoeveel keer past $\\frac{1}{4}$ in $\\frac{1}{2}$?",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 1,
            "label": "1/2 ÷ 1/4 = 2 (twee kwarten passen in een half)",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Delen door een breuk = keer het omgekeerde. Stap 1: draai $\\frac{1}{4}$ om → $\\frac{4}{1}$. Stap 2: $\\frac{1}{2} \\times \\frac{4}{1}$ = $\\frac{4}{2}$ = 2. Antwoord: 2.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2} \\times \\frac{4}{1}$ = $\\frac{4}{2}$ = 2.",
          "1": "$\\frac{1}{8}$ is het resultaat van vermenigvuldigen: $\\frac{1}{2} \\times \\frac{1}{4}$ = $\\frac{1}{8}$. Maar je moet delen, niet vermenigvuldigen. Draai $\\frac{1}{4}$ om naar $\\frac{4}{1}$ en vermenigvuldig dan.",
          "2": "$\\frac{2}{4}$ is niet correct. Je hebt de tellers en noemers apart gedeeld (1÷1=1, 2÷4=?). Dat werkt niet bij breuken delen. Gebruik het omgekeerde.",
          "3": "4 is het omgekeerde van $\\frac{1}{4}$, maar je moet dit nog vermenigvuldigen met $\\frac{1}{2}$: $\\frac{1}{2} \\times 4$ = $\\frac{4}{2}$ = 2, niet 4."
        }
      }
    },
    {
      "id": "GET-BREUK-DEEL-003",
      "familyId": "GET-BREUK-DEEL",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "skill": "breuken",
      "subSkill": "breuk_delen",
      "questionType": "multiple_choice",
      "question": "Sophie heeft $\\frac{3}{4}$ liter sap. Ze verdeelt dit in bekertjes van $\\frac{1}{8}$ liter. Hoeveel bekertjes kan ze vullen?",
      "options": ["6", "8", "3", "4"],
      "correctAnswer": 0,
      "conceptId": "divide_fractions_context",
      "variantIndex": 2,
      "group": 8,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "$\\frac{3}{4}$ liter verdeeld in bekertjes van $\\frac{1}{8}$ liter — hoeveel bekertjes?",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 6,
            "denominator": 1,
            "label": "3/4 ÷ 1/8 = 6 bekertjes",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Hoeveel bekertjes van $\\frac{1}{8}$ passen in $\\frac{3}{4}$? Stap 1: draai $\\frac{1}{8}$ om → $\\frac{8}{1}$. Stap 2: $\\frac{3}{4} \\times \\frac{8}{1}$ = $\\frac{24}{4}$ = 6. Sophie kan 6 bekertjes vullen.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{4} \\times 8$ = $\\frac{24}{4}$ = 6 bekertjes.",
          "1": "8 is de noemer van het bekertje, niet het aantal bekertjes. Je moet $\\frac{3}{4} \\div \\frac{1}{8}$ uitrekenen: $\\frac{3}{4} \\times 8$ = 6.",
          "2": "3 is de teller van $\\frac{3}{4}$. Je hebt het omdraaien overgeslagen. $\\frac{3}{4} \\times \\frac{8}{1}$ = $\\frac{24}{4}$ = 6, niet 3.",
          "3": "4 is de noemer van $\\frac{3}{4}$. Vergeet niet het omgekeerde te nemen: $\\frac{1}{8}$ wordt $\\frac{8}{1}$. Dan: $\\frac{3}{4} \\times 8$ = 6."
        }
      }
    }
  ]
}
